/**
 * @generated SignedSource<<5965762b6de1b7f17f786507c5815d25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeRoleOverviewContent_widget$data = {
  readonly roleContent: {
    readonly roles?: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverviewListItem_role">;
    }>;
    readonly subscriptionKey?: string;
  };
  readonly " $fragmentType": "WidgetEmployeeRoleOverviewContent_widget";
};
export type WidgetEmployeeRoleOverviewContent_widget$key = {
  readonly " $data"?: WidgetEmployeeRoleOverviewContent_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverviewContent_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeRoleOverviewContent_widget",
  "selections": [
    {
      "alias": "roleContent",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EmployeeRole",
              "kind": "LinkedField",
              "name": "roles",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetEmployeeRoleOverviewListItem_role"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "WidgetEmployeeRoleOverviewContentListMedium",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeRoleOverview",
  "abstractKey": null
};

(node as any).hash = "b2c5183a73f11bbe2ed9b872f1178841";

export default node;
